{
	"name": "@prismicio/client",
	"version": "7.21.6",
	"description": "The official JavaScript + TypeScript client library for Prismic",
	"keywords": [
		"typescript",
		"client",
		"helpers",
		"types",
		"utils",
		"toolbox",
		"cms",
		"prismic",
		"prismic.io"
	],
	"repository": {
		"type": "git",
		"url": "ssh://git@github.com/prismicio/prismic-client.git"
	},
	"license": "Apache-2.0",
	"author": "Prismic <contact@prismic.io> (https://prismic.io)",
	"sideEffects": false,
	"type": "module",
	"exports": {
		".": {
			"import": "./dist/index.js",
			"require": "./dist/index.cjs"
		},
		"./richtext": {
			"import": "./dist/richtext.js",
			"require": "./dist/richtext.cjs"
		},
		"./package.json": "./package.json"
	},
	"main": "./dist/index.cjs",
	"module": "./dist/index.js",
	"react-native": "./dist/index.js",
	"types": "./dist/index.d.cts",
	"typesVersions": {
		"*": {
			"*": [
				"dist/index.d.ts"
			],
			"richtext": [
				"dist/richtext.d.ts"
			]
		}
	},
	"files": [
		"dist",
		"src"
	],
	"scripts": {
		"build": "tsdown",
		"dev": "tsdown --watch",
		"format": "prettier --write .",
		"prepare": "npm run build",
		"lint": "oxlint --deny-warnings",
		"types": "tsc --noEmit",
		"unit": "vitest run --coverage",
		"unit:watch": "vitest watch",
		"test": "npm run lint && npm run types && npm run unit && npm run build"
	},
	"dependencies": {
		"imgix-url-builder": "^0.0.6"
	},
	"devDependencies": {
		"@prismicio/e2e-tests-utils": "^1.14.0",
		"@prismicio/types-internal": "^3.16.1",
		"@trivago/prettier-plugin-sort-imports": "^4.3.0",
		"@types/node": "^24.10.0",
		"@vitest/coverage-v8": "^4.0.6",
		"oxlint": "^1.26.0",
		"prettier": "^3.6.2",
		"prettier-plugin-jsdoc": "1.3.3",
		"tsdown": "^0.16.1",
		"typescript": "^5.9.3",
		"vitest": "^4.0.6"
	},
	"engines": {
		"node": ">=14.15.0"
	},
	"publishConfig": {
		"access": "public"
	}
}
